import { Filter } from "lucide-react";
import { withT } from "neetocommons/react-utils";
import { Filters as NeetoFilters } from "neetofilters/v2";

const FilterButton = withT(({ t, buttonProps, ...props }) => (
  <div>
    <NeetoFilters
      buttonProps={{
        "data-testid": "filter-button",
        icon: Filter,
        variant: "ghost",
        tooltipProps: {
          content: t("neetoMolecules.common.filter"),
          position: "bottom",
          touch: ["hold", 500],
        },
        label: null,
        ...buttonProps,
      }}
      {...props}
    />
  </div>
));

export default FilterButton;
